/*
 * File: \packages\lib\globalVariable.js
 * File Created: 2022-03-31 09:59:46
 * Author: Li Haifeng
 * -----
 * Last Modified: 2022-06-27 11:26:58
 * Modified By: Ocean Li ���
 */
import validate from "./validate.js";
import config from "../config.js";
import log from "./log.js";

const { error: Err, warn } = log;

export default class MxGenerator {
  constructor(apis) {
    let existMxRe = validate.checkHasGlobalMx();
    if (
      existMxRe === validate.globalMxStatus.self ||
      existMxRe === validate.globalMxStatus.notExist
    ) {
      this._mxName = config.globalName;
    } else if (existMxRe === validate.globalMxStatus.existNotSelf) {
      this._mxName = config.aliasName;
    } else {
      this._mxName = config.globalName;
    }
    this._globalMx = window[this._mxName];
    if (!this._globalMx) {
      this._globalMx = {};
    }
    this.apis = apis;
    if (!this.apis) {
      this.apis = [];
    }
  }

  generate(methods) {
    if (!Array.isArray(methods)) {
      error(1000);
    }
    methods.forEach((m) => {
      const { name, fn } = m;
      if (!name) {
        error(1001, "name");
      }
      if (!fn) {
        error(1001, "fn");
      }
      if (this._globalMx.hasOwnProperty(name)) {
        error(1001, `api ${name} already exist, please use mx.${name}()`);
      }
      if (checkFn(this.apis, name)) {
        this._globalMx[name] = resolveFn(fn);
      }
    });
    window[this._mxName] = this._globalMx;
    // 全局变量上添加专属标记，用于区分其他框架全局变量
    if (
      this._mxName === config.globalName &&
      !window[this._mxName].hasOwnProperty("identify")
    ) {
      window[this._mxName]["identify"] = config.identify;
    }
  }

  setGlobalApi(name, fn) {
    this._globalMx[name] = fn;
  }

  setApi(method) {
    const { name, fn } = method;
    if (!name) {
      error(1001, "name");
    }
    if (!fn) {
      error(1001, "fn");
    }
    this._globalMx = window[this._mxName];
    this._globalMx[name] = resolveFn(fn);
    window[this._mxName] = this._globalMx;
  }

  addOtherApis(methods) {
    if (!Array.isArray(methods)) {
      error(1000);
    }
    this._globalMx = window[this._mxName];
    methods.forEach((m) => {
      const { name, fn } = m;
      if (!name) {
        error(1001, "name");
      }
      if (!fn) {
        error(1001, "fn");
      }
      if (this._globalMx.hasOwnProperty(name)) {
        warn(`api ${name} already exist, please use mx.${name}()`);
        return;
      }
      this._globalMx[name] = resolveFn(fn);
    });
    window[this._mxName] = this._globalMx;
  }
}

const error = (code, msg) => {
  Err(code, `${config.errorCode[code.toString()]}: ${msg}`);
}

/*
 * 创建全局方法
 * callback方式：mx.func({..args, success, fail})
 * 或
 * promise方式：mx.func(..args).then().catch()
 */
const resolveFn = (fn) => {
  return async function (...params) {
    // callback方式
    if (
      Array.isArray(params) &&
      params.length === 1 &&
      Object.prototype.toString.call(params[0]) === "[object Object]" &&
      (params[0].hasOwnProperty("success") || params[0].hasOwnProperty("fail"))
    ) {
      let param = params[0];
      let success = null;
      if (param && param.hasOwnProperty("success")) {
        success = param["success"];
      }
      let fail = null;
      if (param && param.hasOwnProperty("fail")) {
        fail = param["fail"];
      }
      let p = [];
      Object.keys(param).forEach((key) => {
        if (key !== "success" && key !== "fail") {
          p.push(param[key]);
        }
      });
      execFn(fn, p, success, fail, false);
    }
    // promise方式
    else {
      const promiseCall = async function (resolve, reject) {
        if (!params) {
          params = [];
        }
        execFn(fn, params, resolve, reject, true);
      };
      return new Promise(promiseCall);
    }
  };
};

const execFn = async function (fn, params, success, fail, isPromise) {
  try {
    if (isAsyncFn(fn)) {
      const res = await fn(...params);
      if (!isPromise && success) {
        success(res);
      } else {
        success(res);
      }
    } else {
      const res = fn(...params);
      if (res && isPromiseFn(fn, res)) {
        res
          .then((res) => {
            if (!isPromise && success) {
              success(res);
            } else {
              success(res);
            }
          }, (err) => {
            if (!isPromise && fail) {
              fail(err);
            } else {
              fail(err);
            }
          })
          .catch((e) => {
            if (!isPromise && fail) {
              fail(e);
            } else {
              fail(e);
            }
          });
      } else {
        if (!isPromise && success) {
          success(res);
        } else {
          success(res);
        }
      }
    }
  } catch (err) {
    if (!isPromise && fail) {
      fail(err);
    } else {
      fail(err);
    }
  }
};

const checkFn = (apis, name) => {
  return apis.includes(name);
};

const isPromiseFn = (fn, fnExec) => {
  return (
    fn &&
    (Object.prototype.toString.call(fn) === "[object Promise]" ||
      (typeof fnExec.then === "function" && typeof fnExec.catch === "function"))
  );
};

const isAsyncFn = (fn) => {
  return (
    (fn && Object.prototype.toString.call(fn) === "[object AsyncFunction]") ||
    fn.toString().includes("return _regenerator.default.async(function")
  );
};
